import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { useMakeSelector } from 'hooks/use-make-selector';
import { makeGetCategoryPathFromId } from 'redux/modules/taxonomy/selectors';

import { Card } from '@johnlewispartnership/wtr-ingredients/ingredients/Card';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';

import styles from '../index.scss';

export type CardNavLinkProps = {
  thumbnail?: {
    dynamicImages?: {
      highQuality95: string;
    };
    altText?: string;
  };
  title: string;
  visible: boolean;
  categoryId?: string | undefined;
  path: string | undefined;
};

const CardNavLink = ({ categoryId, path, thumbnail, title, visible }: CardNavLinkProps) => {
  const pathFromCategoryId = useMakeSelector(makeGetCategoryPathFromId, categoryId);

  const formattedUrl = path || pathFromCategoryId;
  const imagePath = thumbnail?.dynamicImages?.highQuality95;

  return (
    <li className={classNames({ [styles.hidden]: !visible })} key={`${title}${formattedUrl}`}>
      <TextLink
        component={Link}
        aria-label={`Category: ${title}`}
        to={formattedUrl}
        className={styles.a}
        underline="hover"
      >
        <Card
          fullWidth
          image={
            imagePath && (
              <img
                aria-hidden="true"
                src={imagePath}
                alt={thumbnail?.altText || title}
                {...(!visible && { loading: 'lazy' })}
              />
            )
          }
        >
          <Typography>{title}</Typography>
        </Card>
      </TextLink>
    </li>
  );
};

export default CardNavLink;
